import 'jquery';

const app_header = (function() {

  //
  //  Initialization / termination
  //
  const init = () => {
    // Watch for nav toggle clicks
    $('.app-header__nav-toggle').click( function( e ) {
      
      e.preventDefault();
      
      if ( $('.app-header__nav').hasClass( 'app-header__nav--open' ) ) {
        $('.app-header__nav').removeClass( 'app-header__nav--open' );
        $('html').removeClass( 'nav-open' );
      } else {
        $('.app-header__nav').addClass( 'app-header__nav--open' );
        $('html').addClass( 'nav-open' );
      }
    });

    // Watch for search form toggle clicks
    $('.app-header form.search-form label').click(function() {
      if ($('.app-header .search-form__field').hasClass('search-form__field--visible')) {
        toggleSearchClose();
      }
    });
    // Watch for focus on the search to toggle it open
    $('.app-header input.search-form__field').on('focus', function() {
      if (!$(this).hasClass('search-form__field--visible')) {
        toggleSearchOpen();
      }
    });
    // Watch for focus to be lost on the search to toggle it closed
    $('.app-header input.search-form__field').on('focusout', function() {
      if ($(this).hasClass('search-form__field--visible')) {
        toggleSearchClose();
      }
    });
  };

  const toggleSearchOpen = () => {
    $('.app-header form.search-form label').addClass('search-form__label--active');
    $('.app-header form.search-form .search-form__field').addClass('search-form__field--visible');
    $('.app-header form.search-form input[type=submit]').addClass('search-form__submit--active');
  };

  const toggleSearchClose = () => {
    $('.app-header .search-form__field').removeClass('search-form__field--visible').addClass('search-form__field--transition-out');
    $('.app-header .search-form input[type=submit]').removeClass('search-form__submit--active');

    setTimeout(function(){
      $('.app-header .search-form__field').removeClass('search-form__field--transition-out');
      $('.app-header .search-form__field').blur();
      $('.app-header form.search-form label').removeClass('search-form__label--active');
    }, 250);
  };

  return {
    init: init,
  };
})();

$(document).ready(function() {
  app_header.init();
});


// WEBPACK FOOTER //
// ./scripts/partials/app-header.js